// @flow

import React from 'react';
export function SelectArrowIcon() {
  return (
    <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.09832 5.5L0.901686 5.5C0.150689 5.5 -0.269991 4.74649 0.19399 4.2324L3.29231 0.799447C3.65265 0.400184 4.34735 0.400184 4.70769 0.799447L7.80601 4.23239C8.26999 4.74649 7.84931 5.5 7.09832 5.5ZM0.901685 8.5H7.09831C7.84931 8.5 8.26999 9.25351 7.80601 9.76761L4.70769 13.2006C4.34735 13.5998 3.65265 13.5998 3.29231 13.2006L0.19399 9.7676C-0.269991 9.25351 0.150689 8.5 0.901685 8.5Z"
        fill="#5C5F62"
      />
    </svg>
  );
}
